/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Header from '../Header'
import Input from '../Input'
import { SearchGrayIcon, InputClearIcon } from '../../conf/images'
import './index.css'
import { useDebounce } from '../../hooks'
interface SearchBarProps {
    onChange?: (value: string) => void
    placeholder?: string
    onCancel?: () => void
    debounce?: number
    position?: 'relative' | 'fixed'
}
const SearchBar: React.FC<SearchBarProps> = (props) => {
    const {
        onChange = () => undefined,
        onCancel = () => undefined,
        placeholder,
        debounce = 500,
        position = 'fixed',
    } = props
    const [searchValue, setSearchValue] = useState('')
    const debounceState = useDebounce(searchValue, debounce)
    useEffect(() => {
        onChange(searchValue)
    }, [debounceState])
    return (
        <Header
            className={`${position === 'fixed' ? '' : 'relative-header'}`}
            backable={false}
        >
            <Input
                value={searchValue}
                onChange={setSearchValue}
                className='bot-search-input'
                placeholder={placeholder}
                maxLength={500}
                prefix={
                    <img
                        className='bot-search-input-icon'
                        src={SearchGrayIcon}
                        alt='search'
                    />
                }
                suffix={
                    searchValue.trim() && (
                        <img
                            className='bot-search-input-clear-icon icon'
                            src={InputClearIcon}
                            onClick={() => setSearchValue('')}
                            alt='clear'
                        />
                    )
                }
            />
            <span
                className='bot-store-cancel-button'
                onClick={() => {
                    onCancel()
                }}
            >
                取消
            </span>
        </Header>
    )
}

export default SearchBar
